import { Keypair, PublicKey } from '@solana/web3.js';
import { encryptData, decryptData, deriveKeyFromPassword } from './CryptoHelpers';
import { getSDK as getSolanaSDK } from '../sdk/SolanaInstance';

export async function getWalletBalance(publicKey) {
  const connection = getSolanaSDK();
  return await connection.getBalance(new PublicKey(publicKey));
}

export async function walletHasSufficientFunds(publicKey, thresholdLamports = 100_000) {
  const balance = await getWalletBalance(publicKey);
  return balance >= thresholdLamports;
}